import { ReactNode } from "react";

import { Container } from "../../elements/Container";
import { styles } from "./DisclaimerText.style";

export interface DisclaimerTextProps {
  children?: ReactNode;
}

export const DisclaimerText = (props: DisclaimerTextProps) => {
  const { children } = props;
  return (
    <div className={styles.whiteBackground()}>
      <Container>
        <div className={styles.textWrapper()}>{children}</div>
      </Container>
    </div>
  );
};
